import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HistoryChangesService {
  private history: string[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _location: Location,
  ) {
    this.detectHistoryChanges();
  }

  detectHistoryChanges() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(({ urlAfterRedirects }: NavigationEnd) => {
        const fullUrl = window.location.href + urlAfterRedirects;
        this.history = [...this.history, fullUrl];
      });
  }

  safeBackNavigation() {
    this.history.pop();
    if (this.history.length > 0) {
      const previouslyURL = this.history[this.history.length - 1];
      const urlDomain = new URL(previouslyURL).hostname;
      // ensure domain is the same
      if (urlDomain === window.location.hostname) {
        this.router.navigateByUrl(previouslyURL);
      } else {
        this.router.navigate(['/']);
      }
    } else {
      this.router.navigate(['/']);
    }
  }
}
